import '../assets/scss/base.scss';
import React from "react";
import { graphql, StaticQuery } from "gatsby";
import Metadata from '../components/sitemetadata';
import ReactFullpage from '@fullpage/react-fullpage';
import { withPrefix } from 'gatsby';
// import videoCover from '../assets/video/cover.jpg';

export default (props) => (

  <StaticQuery
    query={graphql`
    query Content {
      allMarkdownRemark(filter: {}, sort: {order: ASC, fields: fileAbsolutePath}) {
        nodes {
          html
          frontmatter {
            title
            image {
              childImageSharp {
                fluid(maxWidth: 1920, jpegProgressive: true, quality: 70, cropFocus: CENTER) {
                  src
                }
              }
            }
          }
        }
      }
    }
    `}
    render={data => {

      const content = data.allMarkdownRemark.nodes;

      var slidelist = content.map(function(slide){
        if (slide.html) {
          var html = <div className="text" dangerouslySetInnerHTML={{ __html: slide.html }} />
        }

        var slideClasses = 'slide';
        slideClasses += ' slide-' + slide.frontmatter.title;

        if (slide.frontmatter.title === '1') {
          return (
            <div className="slide hero" style={{backgroundImage: `url(${slide.frontmatter.image.childImageSharp.fluid.src})` }}>
              {html}
              <div className="tint"></div>
              {/* <video id="heroVideo" autoPlay="autoplay" loop muted="muted" title="Intro Video">
                <source src="https://news.fullerton.edu/photos/2019/native-american-heritage-month/cover.webm" type="video/webm; codecs=vp9,vorbis" />
                <source src="https://news.fullerton.edu/photos/2019/native-american-heritage-month/cover.mp4" type="video/mp4" />
                <track kind="descriptions"  src={ withPrefix('/cover.html') } />
              </video> */}
            </div>
          )
        } else {
          
          if (slide.frontmatter.title == 7 || slide.frontmatter.title == 9) {
            slideClasses += ' portrait';
          }

          return (
            <div className={slideClasses} style={{backgroundImage: `url(${slide.frontmatter.image.childImageSharp.fluid.src})` }}>
              {html}
              {/* <img src={slide.frontmatter.image.childImageSharp.fluid.src} alt="Students move in to CSUF housing." /> */}
            </div>
          )
        }
      })


      // var log = document.getElementById('heroVideo');
      // console.log(log);

      // function toggleMute() {

      //   var video=document.getElementById('heroVideo');
      
      //   if(video.muted){
      //     video.muted = false;
      //   } else {
      //     video.muted = true;
      //   }
      
      // }

      return (
        <React.Fragment>
          <Metadata />
          <noscript>Some page features may require javascript to run.</noscript>
          <div id="skipnav">
            <a href="#MainContent">Skip to Content (Press Enter)</a>
          </div>
          <header>
            <a href="http://news.fullerton.edu" id="branding">CSUF News Center</a>
          </header>
          <ReactFullpage
          // pluginWrapper
          licenseKey='OPEN-SOURCE-GPLV3-LICENSE'
          // scrollBar='true'
          // autoScrolling='false'
          slidesNavigation='true'
          slidesNavPosition='top'
          controlArrows='true'
          render={({ state, fullpageApi }) => {
            return (
              <ReactFullpage.Wrapper fullpageApi={fullpageApi}>
                {/* <button className="clickContainer" onClick={() => fullpageApi.moveSlideRight()}> */}
                  <div className="section" id="MainContent">
                    {/* <div className="slide hero" style={{ background: 'red' }} >
                      <div className="text">
                        <h1>Commencement 2019</h1>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In nisl sem, convallis at ex vitae, porttitor mollis dolor. Sed viverra dolor magna, rhoncus finibus magna porttitor sed. Sed id scelerisque velit.</p>
                      </div>
                      <div class="tint"></div>
                      <img src={image1} alt="Placeholder" />
                    </div> */}
                    {slidelist}
                  </div>
                {/* </button> */}
              </ReactFullpage.Wrapper>
            );
          }}
        />
      </React.Fragment>
    )

  }}
  />
)